import { render, staticRenderFns } from "./Certificaciones.vue?vue&type=template&id=57b2ed68&"
import script from "./Certificaciones.vue?vue&type=script&lang=js&"
export * from "./Certificaciones.vue?vue&type=script&lang=js&"
import style0 from "./Certificaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports